const Identity = () => import('@/views/Identity')

export default [
  {
    path: '/identity',
    component: Identity,
    meta: { requireAuth: true }
  }
]
